import React from "react";
import {useSelector} from "react-redux";
import {organisationSelectors} from "../../organisationSelectors";
import {checkDateExpiredFromISO, formatDate} from "../../../../infrastructure/utils/dateUtils";
import {useLocation, useNavigate} from "react-router-dom";
import {format} from "react-string-format";
import * as urls from '../../../../infrastructure/variables/urls'
import {useIntl} from "react-intl";

export const TrialWarning = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const intl = useIntl()

    const isInSubscriptionPage = location.pathname.toLowerCase().includes('subscription')

    const organisation = useSelector(organisationSelectors.getSelectedOrganisation())

    const redirectToSubscriptionPage = () => {
        navigate(format(urls.ORGANISATION_SUBSCRIPTION_URL, organisation.id))
    }

    return (

        <>
            {checkDateExpiredFromISO(new Date().toISOString(), organisation.trialExpireDate) ?
                <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed mb-8 p-6">
                    <div className='d-flex flex-stack flex-grow-1 justify-content-start'>
                        <i className='ki-duotone ki-information fs-2x me-4'>
                            <svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 512 512' fill='#009EF7'>
                                <path
                                    d='M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'/>
                            </svg>
                        </i>
                        <span
                            className="fs-6">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.TRIAL_WARNING.TRIAL_EXPIRING"}, {date: formatDate(organisation.trialExpireDate)})}</span>
                    </div>
                    {!isInSubscriptionPage &&
                        <div className='d-flex flex-stack'>
                            <button className='btn btn-sm btn-primary' onClick={redirectToSubscriptionPage}>Go to Subscription Page</button>
                        </div>
                    }
                </div>
                :
                <div className="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-8 p-6">
                    <div className='d-flex flex-stack flex-grow-1 justify-content-start'>
                        <i className='ki-duotone ki-information fs-2x me-4'>
                            <svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 512 512' fill='#F1416C'>
                                <path
                                    d='M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'/>
                            </svg>
                        </i>
                        <span className="text-danger fs-6">{intl.formatMessage({id: "ORGANISATION.SUBSCRIPTION.TRIAL_WARNING.NO_PACKAGE"})}</span>
                    </div>
                    {!isInSubscriptionPage &&
                        <div className='d-flex flex-stack'>
                            <button className='btn btn-sm btn-danger' onClick={redirectToSubscriptionPage}>Go to Subscription Page</button>
                        </div>
                    }
                </div>
            }
        </>
    )
}